export enum Type {
  CREATE_VIDEO_ZIP_REQUEST = 'app/videoZipRequest/CREATE_VIDEO_ZIP_REQUEST',
  CREATE_VIDEO_ZIP_REQUEST_SUCCESS = 'app/videoZipRequest/CREATE_VIDEO_ZIP_REQUEST_SUCCESS',
  CREATE_VIDEO_ZIP_REQUEST_FAILURE = 'app/videoZipRequest/CREATE_VIDEO_ZIP_REQUEST_FAILURE',

  GET_VIDEO_ZIP_REQUEST = 'app/videoZipRequest/GET_VIDEO_ZIP_REQUEST',
  GET_VIDEO_ZIP_REQUEST_SUCCESS = 'app/videoZipRequest/GET_VIDEO_ZIP_REQUEST_SUCCESS',
  GET_VIDEO_ZIP_REQUEST_FAILURE = 'app/videoZipRequest/GET_VIDEO_ZIP_REQUEST_FAILURE',

  RESET_VIDEO_ZIP_REQUEST_STATE = 'app/videoZipRequest/RESET_VIDEO_ZIP_REQUEST_STATE',
}
